import React from "react";

const Success = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.6784 1.80673C11.2491 1.39776 10.5536 1.39776 10.1244 1.80673L3.58879 8.0339L1.85098 6.61156C1.42762 6.20815 0.741268 6.20815 0.317527 6.61156C-0.105842 7.01495 -0.105842 7.66924 0.317527 8.07263L2.91382 10.1974C3.33719 10.6009 4.02353 10.6009 4.44728 10.1974C4.48977 10.157 4.52529 10.112 4.55935 10.0669C4.56557 10.0614 4.57253 10.0575 4.57876 10.0519L11.6784 3.287C12.1072 2.87838 12.1072 2.21535 11.6784 1.80673Z" fill="white" />
  </svg>
);

export default Success;
